<div class="footer">
  @for (operation of operations; track $index) {
    <div class="footer__nav-button">
      @if(operation.router_link !== 'search') {
        <button
          mat-button
          class="footer__nav-action"
          routerLinkActive="footer__nav-button--active"
          [queryParams]="getQueryParams()"
          [routerLink]="operation.router_link"
        >
          <span class="footer__nav-item">
            <mat-icon aria-hidden="true">{{operation.icon}}</mat-icon>
            <span class="footer__nav-label">{{operation.name | translate}}</span>
          </span>
        </button>
      }
      @else {
        <button
          mat-button
          class="footer__nav-action"
          (click)="goToSearch()"
          [ngClass]="{'footer__nav-button--active' : currentStateName === 'home.primus.search' }"
        >
          <span class="footer__nav-item">
            <mat-icon aria-hidden="true">{{operation.icon}}</mat-icon>
            <span class="footer__nav-label">{{operation.name | translate}}</span>
          </span>
        </button>
      }

    </div>
  }
</div>
